import React from "react";
import "./DataService.scss";

const DataService = () => {
  return (
    <div
      className="signup-content2 "
      style={{
        paddingLeft: "2%",
        paddingRight: "2%",
        paddingTop: "1%",
        height: "100vh",
      }}
    >
     <main className="main-content">
        <div className="header">
            <div className="card">
          <div>
            <h2>311 Open Data & API Portal</h2>
            <p>Real-time 311 request data available via REST APIs for cities, departments, and developers.</p>
          </div>
          <div style={{display:'flex' ,justifyContent:'center'}}>
            <button className="btn">Generate API Key</button>
            <button className="btn-outline">View API Docs</button>
          </div>
          </div>
        </div>

        <div className="row mt-3">
          <div className="col-6">
          <div className="card">
            <h4>Total 311 Requests</h4>
            <div className="stats">
              <div><strong>Today</strong><p>135</p></div>
              <div><strong>Traffic</strong><p>982</p></div>
            </div>
            <h5>Top 5 Reported Issues</h5>
            <ul className="bars">
              <li><span>Graffiti</span><div style={{ width: "80%" }} /></li>
              <li><span>Pothole</span><div style={{ width: "60%" }} /></li>
              <li><span>Noise</span><div style={{ width: "45%" }} /></li>
              <li><span>Trash</span><div style={{ width: "25%" }} /></li>
              <li><span>Lights</span><div style={{ width: "10%" }} /></li>
            </ul>

          </div>
          </div>

      <div className="col-6">
      <div className="card" style={{height:'100%'}}>
            <h4>Live API Preview</h4>
            <div style={{display:'flex', justifyContent:'center' }}>
              <button className="btn">Copy API Preview</button>
              <button className="btn-outline">Test Request</button>
            </div>
            <code style={{height:'10%' ,margin:'0.5rem'}} className="mt-3">
              GET /api/requests?city=NewYork
              &dept=sanitation&status=open

            </code>
            <code style={{height:'60%'}} className="mt-3">
              Preview
            </code>

          </div>


      </div>





        </div>

        <div className="card mt-4" style={{ padding: "20px", border: "1px solid #ddd", borderRadius: "8px" }}>
      <div>
      <h2 style={{ textAlign: "left", display: "flex", alignItems: "center", gap: "10px" }}>
    <i className="fas fa-database" style={{ color: "#555" }}></i>
    Dallas 311 Open Data API
  </h2>
        <p style={{ textAlign: "left", fontFamily: "monospace", padding: "10px", borderRadius: "4px" }}>
          GET https://data.cityofnewyork.us/resource/erm2-nwe9.json?agency=NYPD&status=Open
          <br />
          App Token: <i>your-app-token</i>
        </p>
      </div>
      <div style={{ textAlign: "left", marginTop: "10px" }}>
        <button className="btn" onClick={() => window.open("https://data.cityofnewyork.us/resource/erm2-nwe9.json?agency=NYPD&status=Open", "_blank")}>
          Test Request
        </button>
        <button className="btn-outline" onClick={() => window.open("https://dev.socrata.com/foundry/data.cityofnewyork.us/erm2-nwe9", "_blank")} style={{ marginLeft: "10px" }}>
          View API Docs
        </button>
      </div>
    </div>

    <div className="card mt-4" style={{ padding: "20px", border: "1px solid #ddd", borderRadius: "8px" }}>
      <div>
      <h2 style={{ textAlign: "left", display: "flex", alignItems: "center", gap: "10px" }}>
    <i className="fas fa-database" style={{ color: "#555" }}></i>
    Dallas 311 City Specific Data API
  </h2>

        <p style={{ textAlign: "left", fontFamily: "monospace", padding: "10px", borderRadius: "4px" }}>
          GET https://data.cityofnewyork.us/resource/erm2-nwe9.json?agency=NYPD&status=Open
          <br />
          App Token: <i>your-app-token</i>
        </p>
      </div>
      <div style={{ textAlign: "left", marginTop: "10px" }}>
        <button className="btn" onClick={() => window.open("https://data.cityofnewyork.us/resource/erm2-nwe9.json?agency=NYPD&status=Open", "_blank")}>
          Test Request
        </button>
        <button className="btn-outline" onClick={() => window.open("https://dev.socrata.com/foundry/data.cityofnewyork.us/erm2-nwe9", "_blank")} style={{ marginLeft: "10px" }}>
          View API Docs
        </button>
      </div>
    </div>


    <div className="card mt-4" style={{ padding: "20px", border: "1px solid #ddd", borderRadius: "8px" }}>
      <div>
      <h2 style={{ textAlign: "left", display: "flex", alignItems: "center", gap: "10px" }}>
    <i className="fas fa-database" style={{ color: "#555" }}></i>
    Dallas 311 Department Specific Data API
  </h2>
      
        <p style={{ textAlign: "left", fontFamily: "monospace", padding: "10px", borderRadius: "4px" }}>
          GET https://data.cityofnewyork.us/resource/erm2-nwe9.json?agency=NYPD&status=Open
          <br />
          App Token: <i>your-app-token</i>
        </p>
      </div>
      <div style={{ textAlign: "left", marginTop: "10px" }}>
        <button className="btn" onClick={() => window.open("https://data.cityofnewyork.us/resource/erm2-nwe9.json?agency=NYPD&status=Open", "_blank")}>
          Test Request
        </button>
        <button className="btn-outline" onClick={() => window.open("https://dev.socrata.com/foundry/data.cityofnewyork.us/erm2-nwe9", "_blank")} style={{ marginLeft: "10px" }}>
          View API Docs
        </button>
      </div>
    </div>
      </main>



    </div>
  );
};

export default DataService;
